import React from 'react';
import OddsEvent from './components/oddsEvent/OddsEvent';
import { Footer } from './components/footer/Footer';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";

import OddsList from './components/oddsList/OddsList';
import ErrorView from './components/errors/ErrorView';
import SocketProvider from "./components/socketContext";
import { QueryClient, QueryClientProvider } from 'react-query'
import RouteUtils from './utils/routeUtils';
import LineHistory from './components/lineHistory/LineHistory'
import { Futures } from './components/futures/Futures';
const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#074589',
            main: '#074589',
            dark: '#074589',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff7961',
            main: '#f44336',
            dark: '#ba000d',
            contrastText: '#000',
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 992,
            largeHeaderStart: 992,
            lg: 1280,
            largeHeaderEnd: 1313,
            xl: 1920,
        },
    },
});

const queryClient = new QueryClient()
const LeagueFilter = ":league(nfl|nba|college-football|college-basketball|nhl|mlb)";
const MarketFilter = ":market(spreads|moneylines|totals|puck-lines|run-lines)";
const SeasonFilter = ":season(preseason|playoffs)?";
const GameSlugFilter = ":gameSlug([\\S]+-vs-[\\S]+-odds-[\\S]+-[\\S]+)";
const LineHistoryFilter = ":gameSlug([\\S]+-vs-[\\S]+-line-history-[\\S]+-[\\S]+)";
const FutureSlugFilter = ":slug";

function App() {
    return (
        <Router>
            <MuiThemeProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <SocketProvider>
                        {/*<OddsAppBar />*/}
                        {/*<OddsNavBar />*/}
                        <Switch>
                            <Route exact strict sensitive path='/:url([a-z/]*[A-Z]+[a-z/]*)/' render={props => {
                                const path = props.location.pathname
                                return <Redirect to={`${path.toLowerCase()}`} />
                            }}
                            />
                            <Route exact path={`/${LeagueFilter}/${MarketFilter}/${SeasonFilter}/:gameTime`}>
                                <OddsList />
                            </Route>
                            <Route exact path={`/${LeagueFilter}/${MarketFilter}/:gameTime?`}>
                                <OddsList />
                            </Route>
                            <Route exact path={`/${LeagueFilter}`} render={props => (
                                <Redirect
                                    to={`/${props.match.params.league}/${RouteUtils.getDefaultMarketFilter(props.match.params.league)}`} />
                            )} />
                            <Route exact path={`/${LeagueFilter}/odds`} render={props => (
                                <Redirect
                                    to={`/${props.match.params.league}/${RouteUtils.getDefaultMarketFilter(props.match.params.league)}`} />
                            )} />
                            <Route exact path={`/:league/${MarketFilter}`} render={props => (
                                <Redirect to={`/${props.match.params.league}`} />
                            )} />
                            <Route exact path={`/${LeagueFilter}/${LineHistoryFilter}`}>
                                <LineHistory />
                            </Route>
                            <Route exact path={`/${LeagueFilter}/${GameSlugFilter}`}>
                                <OddsEvent />
                            </Route>
                            <Route exact path={`/${LeagueFilter}/futures-odds`}>
                                <Futures />
                            </Route>
                            <Route exact path={`/${LeagueFilter}/futures-odds/${FutureSlugFilter}`}>
                                <Futures />
                            </Route>
                            <Route exact path='/' render={() => <Redirect to="/nba/spreads/" />} />
                            <Route path='*'>
                                <ErrorView />
                            </Route>
                        </Switch>
                        <Footer />
                    </SocketProvider>
                </QueryClientProvider>
            </MuiThemeProvider>
        </Router>
    );
}

export default App;